import { useTranslations } from 'next-intl';
import { HeroBadge } from './components/HeroBadge';

const HeartGlyph = () => (
  <svg viewBox="0 0 24 24" className={styles.heart} aria-hidden="true">
    <path d="M12 20.3C6.6 16.4 3.2 13.2 3.2 9.4c0-2.3 1.8-4.1 4.1-4.1 1.6 0 3 .9 3.7 2.2.2.4.8.4 1 0 .7-1.3 2.1-2.2 3.7-2.2 2.3 0 4.1 1.8 4.1 4.1 0 3.8-3.4 7-8.8 10.9-.3.2-.7.2-1 0z" />
  </svg>
);

// About hero — "Your knowledge should get more valuable…"
export const Section20 = () => {
  const t = useTranslations();
  return (
    <section className={styles.section}>
      <div className={styles.glow} aria-hidden="true" />
      <div className={styles.wrap}>
        <HeroBadge
          icon={<HeartGlyph />}
          iconClassName="bg-[#EBF0F7] text-mf-blue marketing-dark:bg-mf-coral/20 marketing-dark:text-mf-coral"
          label={t('pages.about.hero.badge')}
        />
        <h1 className={styles.title}>
          {t.rich('pages.about.hero.title', {
            highlight: (chunks) => (
              <span className={styles.highlight}>{chunks}</span>
            ),
          })}
        </h1>
        <p className={styles.sub}>{t('pages.about.hero.sub')}</p>
      </div>
    </section>
  );
};

const styles = {
  // pt clears the fixed header (announcement bar + nav).
  section:
    'relative overflow-hidden marketing-dark:bg-mf-navy pt-[150px] pb-10 text-center',
  glow: [
    'pointer-events-none absolute left-1/2 top-0 h-[460px] w-[1100px] max-w-full -translate-x-1/2',
    '[background:radial-gradient(60%_70%_at_50%_0%,rgba(189,222,255,0.6)_0%,rgba(189,222,255,0.2)_45%,transparent_70%)]',
    'marketing-dark:[background:radial-gradient(60%_70%_at_50%_0%,rgba(58,96,220,0.42)_0%,rgba(26,58,162,0.14)_45%,transparent_70%)]',
  ].join(' '),
  wrap: 'relative z-[2] mx-auto max-w-[1200px] px-6 lg:px-10',
  heart: 'h-3.5 w-3.5 fill-current',
  title:
    'mx-auto max-w-[840px] font-inter text-4xl font-bold leading-[1.06] tracking-[-0.02em] text-mf-off-black-600 marketing-dark:text-white sm:text-5xl lg:text-[56px]',
  highlight: 'text-mf-blue marketing-dark:text-mf-coral',
  sub: 'mx-auto mt-[26px] max-w-[660px] text-lg leading-[1.6] text-mf-gray-600 marketing-dark:text-white/72 lg:text-xl',
};
